// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletLayout {
  padding-inline: 2rem;
  height: 100dvh;
}
.WalletLayout .wallet-card {
  padding: 0;
  height: auto;
  background: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);
  border-radius: 20px;
  text-align: center;
  box-shadow: 0px 6px 16px 0px rgba(0, 170, 116, 0.19);
  overflow: hidden;
}
.WalletLayout .wallet-card__body {
  padding-inline: 3rem;
  padding-block: 2rem;
}
.WalletLayout section > p:first-child {
  font-size: 18px;
  padding-block: 3rem;
  font-weight: 600;
}
.WalletLayout .wallet-card__body > p:first-child {
  font-size: 14px;
  color: #D9D9D9;
  padding-bottom: 1rem;
}
.WalletLayout .wallet-card__body > p:nth-child(2) {
  font-size: 32px;
  font-weight: 700;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  color: white;
}
.WalletLayout .wallet-card__reward-credits {
  background: #F1F3F4;
  padding: 0.75rem;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.WalletLayout .wallet-card__reward-credits-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #1A1A1A;
  font-size: 14px;
  font-weight: 600;
}
.WalletLayout .wallet-card__reward-credits-row svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.WalletLayout .wallet-card__reward-disclaimer {
  font-size: 11px;
  color: #757575;
  margin: 0.25rem 0 0 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}
.WalletLayout .wallet-card__reward-disclaimer svg {
  width: 14px;
  height: 14px;
}
.WalletLayout .wallet-btn {
  display: flex;
  gap: 2rem;
  padding-block: 2rem;
}
.WalletLayout .WalletLayout--warning-btn {
  display: flex;
  gap: 2rem;
}
.WalletLayout .modalClass .wallet-icon {
  text-align: center;
  padding-bottom: 1rem;
}
.WalletLayout .modalClass .funds {
  font-size: 18px;
}
.WalletLayout .modalClass .fundInfo {
  font-size: 16px;
  margin: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Layouts/WalletLayout/walletlayout.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,cAAA;AADJ;AAGI;EACI,UAAA;EACA,YAAA;EACA,mECLY;EDMZ,mBAAA;EACA,kBAAA;EACA,oDAAA;EACA,gBAAA;AADR;AAII;EACI,oBAAA;EACA,mBAAA;AAFR;AAKI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AAHR;AAOI;EACI,eAAA;EACA,cAAA;EACA,oBAAA;AALR;AAQI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AANR;AASI;EACI,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AARR;AAUQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;AARZ;AAYI;EACI,eAAA;EACA,cAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAVR;AAWQ;EACI,WAAA;EACA,YAAA;AATZ;AAaI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAXR;AAcI;EACI,aAAA;EACA,SAAA;AAZR;AAiBQ;EACI,kBAAA;EACA,oBAAA;AAfZ;AAkBQ;EACI,eAAA;AAhBZ;AAmBQ;EAEI,eAAA;EACA,cAAA;AAlBZ","sourcesContent":["@import '../../Styles/sass/variables';\n\n.WalletLayout {\n    padding-inline: 2rem;\n    height: 100dvh;\n\n    .wallet-card {\n        padding: 0;\n        height: auto;\n        background: $primary_gradient1;\n        border-radius: 20px;\n        text-align: center;\n        box-shadow: 0px 6px 16px 0px rgba(0, 170, 116, 0.19);\n        overflow: hidden;\n    }\n\n    .wallet-card__body {\n        padding-inline: 3rem;\n        padding-block: 2rem;\n    }\n\n    section>p:first-child {\n        font-size: 18px;\n        padding-block: 3rem;\n        font-weight: 600;\n        // color: $color_black_400;\n    }\n\n    .wallet-card__body>p:first-child {\n        font-size: 14px;\n        color: #D9D9D9;\n        padding-bottom: 1rem;\n    }\n\n    .wallet-card__body>p:nth-child(2) {\n        font-size: 32px;\n        font-weight: 700;\n        padding-top: 1rem;\n        padding-bottom: 1.5rem;\n        color: white;\n    }\n\n    .wallet-card__reward-credits {\n        background: #F1F3F4;\n        padding: 0.75rem;\n        width: 100%;\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .wallet-card__reward-credits-row {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        color: #1A1A1A;\n        font-size: 14px;\n        font-weight: 600;\n\n        svg {\n            flex-shrink: 0;\n            width: 20px;\n            height: 20px;\n        }\n    }\n\n    .wallet-card__reward-disclaimer {\n        font-size: 11px;\n        color: #757575;\n        margin: 0.25rem 0 0 0;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.25rem;\n        svg {\n            width: 14px;\n            height: 14px;\n        }\n    }\n\n    .wallet-btn {\n        display: flex;\n        gap: 2rem;\n        padding-block: 2rem;\n    }\n\n    .WalletLayout--warning-btn {\n        display: flex;\n        gap: 2rem;\n\n    }\n\n    .modalClass {\n        .wallet-icon {\n            text-align: center;\n            padding-bottom: 1rem;\n        }\n\n        .funds {\n            font-size: 18px;\n        }\n\n        .fundInfo {\n\n            font-size: 16px;\n            margin: 1.5rem;\n        }\n\n\n    }\n\n\n}","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
